import { Component, OnDestroy } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

import { AdminService } from '@shared/services/admin.service';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'app-fullscreen',
  templateUrl: './fullscreen.component.html'
})
export class FullscreenComponent implements OnDestroy {

  routeActive: boolean;
  customize: any;

  constructor(private router: Router,
              private adminService: AdminService) {
    router.events.pipe(untilDestroyed(this)).subscribe(evt => {
      if ((evt instanceof NavigationEnd)) {
        this.routeActive = evt.url === '/version';
      }
    });

    this.getCustomization();
  }

  navigateUrl(): void {
    if (this.routeActive) {
      this.router.navigateByUrl('/');
    }
  }

  getCustomization(): void {
    this.adminService.getCustomization().pipe().subscribe((res) => {
      this.customize = res;
    })
  }

  ngOnDestroy(): void {
    // prevent memory leak when component destroyed
  }
}
